"use client";

import { useShallow } from "zustand/react/shallow";
import { useShellStore } from "@/ui-state/shell.store";

export interface UseShellControls {
  headerVisible: boolean;
  footerVisible: boolean;
  showHeader: () => void;
  hideHeader: () => void;
  showFooter: () => void;
  hideFooter: () => void;
}

export const useShellControls = (): UseShellControls =>
  useShellStore(
    useShallow(
      ({
        footerVisible,
        headerVisible,
        hideFooter,
        hideHeader,
        showFooter,
        showHeader,
      }) => ({
        footerVisible,
        headerVisible,
        hideFooter,
        hideHeader,
        showFooter,
        showHeader,
      })
    )
  );
